import { RestService } from './ResyService';
import { LoginModel } from '@/models';
import { Auth } from './config';
export class Authantication extends RestService {
    
    login(data: LoginModel) {
        const body = JSON.stringify({
            'username': data.username,
            'password': data.password,
        });
        return this.post(Auth.login, body);
    }
}